import { trackGlobalVariableDetails } from "@DSG/Common/DSGTracking";
import CoveoUIConfigHandler from "@DSG/Handlers/Coveo/CoveoUIConfigHandler";
import DisplayCatalogData from "@DSG/Handlers/ProuductList/DisplayCatalogData";
import colorPallete, { bodyFonts, headlineFonts } from "@DSG/MobiusOverrides/styles/variables";
import prepareBreadcrumbStructuredPageData from "@DSG/Overrides/Common/Utilities/prepareBreadcrumbStructuredPageData";
import setPageMetadata from "@DSG/Overrides/Common/Utilities/setPageMetadata";
import { getSelectedBrandPath } from "@DSG/Overrides/Store/Context/ContextSelectors";
import CoveoApplicationState from "@DSG/Store/Data/CoveoApplicationState/CoveoApplicationState";
import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { redirectTo, setStatusCode } from "@insite/client-framework/ServerSideRendering";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import {
  getSearchDataModeActive,
  getSelectedCategoryPath,
  getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { BrandStateContext, getBrandStateByPath } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import loadBrandByPath from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrandByPath";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import {
  getAlternateLanguageUrls,
  getCurrentPage,
  getLocation,
} from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import clearProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearProducts";
import displayProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import translate from "@insite/client-framework/Translate";
import { HideFooter, HideHeader, OpenGraphImage, OpenGraphTitle } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { getPrevCurrentNextQueryString } from "@insite/mobius/utilities/linkElementsManipulation";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface productListingPageStyles {
    page?: MobiusPageProps;
}

export const productListingPageStyles: productListingPageStyles = {
    page: {
        css: css`
            .listing-add-to-cart {
                .addToCartQtyInventoryWrapper {
                    display: flex;
                    flex-direction: column;
                    > div {
                        order: 0;
                    }
                    .inventoryWrapper {
                        order: 2;
                        .inventoryNotifcationMsg {
                            > svg {
                                margin-top: 16px;
                            }
                            > span:not(:empty) {
                                margin: 16px 0 0;
                            }
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 16px;
                        `,
                        css`
                            padding: 0 16px;
                        `,
                        null,
                        css`
                            padding: 0 24px;
                            > div[class*="Wrapper-"] {
                                > div[class*="GridWrapper-"] {
                                    max-width: 1280px;
                                    &.category-top-sellers-carousel {
                                        max-width: 100%;
                                    }
                                }
                            }
                        `,
                    ],
                    "min",
                )}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 16px;
                        `,
                        css`
                            padding: 0 16px;
                        `,
                        null,
                        null,
                    ],
                    "minMax",
                )}
            [class*="AccordionSectionHeader"] {
                &:last-of-type {
                    button {
                        border-bottom: none;
                    }
                }
                button {
                    &,
                    &:focus {
                        background: none;
                        border: 1px solid ${colorPallete.grey300};
                        border-left: none;
                        border-right: none;
                        padding: 16px 0 16px 0;
                    }

                    * {
                        font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                        line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                        font-weight: ${bodyFonts.body2SemiBoldLg.fontWeight};
                        color: ${colorPallete.grey800};
                    }

                    &[aria-expanded="true"] {
                        border-bottom: none;
                    }

                    &[aria-expanded="false"] {
                        &:focus {
                            border-bottom: 1px solid ${colorPallete.grey300} !important;
                        }
                    }
                }
            }

            [class*="AccordionSectionPanel"] {
                border: none;
                padding: 0;
                border-bottom: none;
                padding-bottom: 0;
                max-height: none;

                > [class*="CheckboxGroupStyle"] {
                    display: block;

                    legend {
                        &:first-child {
                            margin: 0;
                        }
                    }
                }

                &:not(hidden) {
                    border-bottom: 1px solid ${colorPallete.grey300};
                    padding-bottom: 24px;
                    margin-top: 2px;
                    
                    &:last-of-type {
                        border-bottom: none;
                    }
                }

                & + [class*="AccordionSectionHeader"] {
                    button {
                        &:focus {
                            border: none;
                            padding: 16px 0 16px 0;
                        }
                    }

                    &:last-of-type {
                        button {
                            &:focus {
                                border: none !important;
                            }
                        }
                    }
                }
            }

            label[for="productsKeywordSearch"] {
                display: none;
            }

            input[data-test-selector="productListSearchWithin"] {
                &:not(.react-datetime-picker__inputGroup__input) {
                    & + [class*="FormFieldClickable"] {
                        height: 48px;
                        [class*="IconWrapper"] {
                            height: 48px;
                            top: 0;
                        }
                    }
                    &,
                    &:focus {
                        padding: 12px 16px;
                        border: 1px solid ${colorPallete.grey400};
                        border-radius: 8px;
                        padding-left: 35px;
                        min-height: 48px;
                    }

                    &::placeholder {
                        color: ${colorPallete.grey600DisabledText};
                    }

                    &:active,
                    &:focus-within {
                        border: 1px solid ${colorPallete.grey800};
                        border-radius: 8px;
                    }

                    font-size: ${bodyFonts.body2RegularSm.fontSize};
                    line-height: ${bodyFonts.body2RegularSm.lineHeight};
                    color: ${colorPallete.grey800};
                }
            }

            .product-list-controls-container {
                > [class*="GridOffset-"] {
                    > [class*="GridItemStyle"] {
                        flex-basis: auto;
                        width: auto;
                        max-width: unset;

                        &:first-child {
                            flex-grow: 1;
                        }
                    }
                }
            }

            [data-test-selector="productList_pagination"] {
                justify-content: center;

                nav {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                ul {
                    margin-bottom: 16px;
                    display: flex;
                    align-items: center;
                }

                .pagination-text {
                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                    line-height: ${bodyFonts.body1RegularLg.lineHeight};

                    > span {
                        font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                        line-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                        font-weight: ${bodyFonts.body1SemiBoldLg.fontWeight};
                    }
                }
            }

            [data-test-selector="pagination_nextButton"] {
                flex-direction: row-reverse;
                padding-left: 16px;
                padding-right: 8px;
            }

            [data-test-selector="pagination_previousButton"],
            [data-test-selector="pagination_nextButton"] {
                [class*="IconWrapper-"] {
                    margin-right: 0;
                    margin-left: 0;
                }
                &,
                &:disabled {
                    background: none;
                }

                &:disabled {
                    border: none;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding-left: 10px;
                                padding-right: 10px;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }

            [data-test-selector="dsg_productList_pagination"] {
                margin: 0;
                color: ${colorPallete.grey800};
                > [class*="PerPageSelect"],
                [data-test-selector="pagination_resultsPerPage"] {
                    display: flex;
                    align-items: center;
                }

                [data-test-selector="pagination_resultsPerPage"] {
                    margin-left: 8px;
                    margin-right: 16px;

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    margin-right: 0;
                                `,
                                null,
                            ],
                            "max",
                        )}

                    li {
                        cursor: pointer;
                        font: ${bodyFonts.body2RegularLg.fontWeight} ${bodyFonts.body2RegularLg.fontSize} /
                            ${bodyFonts.body2RegularLg.lineHeight} ${bodyFonts.body2RegularLg.fontFamily};
                        padding: 2px;
                        width: 32px;
                        height: 32px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        &.active {
                            border: 2px solid ${colorPallete.grey800};
                            border-radius: 4px;
                            font: ${bodyFonts.body2SemiBoldLg.fontWeight} ${bodyFonts.body2SemiBoldLg.fontSize} /
                                ${bodyFonts.body2SemiBoldLg.lineHeight} ${bodyFonts.body2SemiBoldLg.fontFamily};
                        }
                        &:not(:last-child) {
                            margin-right: 8px;
                        }
                    }
                }
            }

            [data-test-selector="productPrice_unitNetPrice"] {
                align-items: center;
                display: flex;
                color: ${colorPallete.grey800};
                .price {
                    font: ${headlineFonts.headline3SemiBoldLg.fontWeight} ${headlineFonts.headline3SemiBoldLg.fontSize} /
                        ${headlineFonts.headline3SemiBoldLg.lineHeight} ${headlineFonts.headline3SemiBoldLg.fontFamily};
                }
                .uom {
                    font: ${bodyFonts.body2RegularLg.fontWeight} ${bodyFonts.body2RegularLg.fontSize} /
                        ${bodyFonts.body2RegularLg.lineHeight} ${bodyFonts.body2RegularLg.fontFamily};
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                .price {
                                    font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                                    line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};
                                }
                                .uom {
                                    font-size: ${bodyFonts.body2RegularSm.fontSize};
                                    line-height: ${bodyFonts.body2RegularSm.lineHeight};
                                }
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            [data-test-selector="productListCards_Grid"] {
                > [class*="GridOffset"] {
                    gap: 40px;
                }

                .priceWrapper {
                    order: 2;
                }

                .productAvailability {
                    order: 1;
                }

                .product-actions-wrapper {
                    order: 3;
                }

                [data-test-selector="priceIncludeVat"] {
                    margin-bottom: 0;
                }
                
                [data-test-selector="productPriceSavingsMessage"] {
                    margin-top: 8px;    
                    display: flex;
                }

                .productAvailability {
                    margin-bottom: 16px;
                }

                .partNumber {
                    margin-bottom: 11px;
                }

                .product-actions-wrapper {
                    margin-top: auto;
                    display: flex;
                    flex-direction: column;
                    .listing-add-to-cart {
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                    }
                }

                [data-test-selector="productDescriptionLink"] {
                    height: 84px;
                }

                .show-add-to-list {
                    display: none;
                }

                [data-test-selector*="productListProductCard"] {
                    position: relative;
                    padding: 2px;
                    [data-test-selector="textBadges"] {
                        position: absolute;
                        left: 4px;
                        top: 4px;
                    }

                    [data-test-selector="productPrice_PricingMessageSignIn"] {
                        padding: 14px 6px;
                    }
                }
            }

            [data-test-selector="productListCards_List"] {
                .add-to-cart-list-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    & + .list-compare-wrapper {
                        display: none;
                    }

                    > .show-add-to-list {
                        line-height: 18px;
                    }

                    > button {
                        width: auto;
                    }
                }
                .addToCartQtyInventoryWrapper {
                    & + div + .list-compare-wrapper {
                        display: none;
                    }
                }

                [data-test-selector*="productListProductCard"] {
                    position: relative;

                    [data-test-selector="textBadges"] {
                        position: absolute;
                        left: 0;
                        top: calc(0% + 40px);
                    }
                }

                .product-left-column {
                    flex: 0 1 171px;
                }

                .priceWrapper {
                    [data-test-selector="productPriceSavingsMessage"] {
                        margin-top: 4px;
                    }
                }

                .card_container__wrapper {
                    &:last-child {
                        border-bottom: 0;
                        & > div {
                            border-bottom: 0;
                        }
                    }
                }
            }

            /* Mobile product design */
            [data-test-selector="cardListProductsNarrow"] {
                .show-add-to-list,
                .list-compare-wrapper {
                    display: none;
                }
                [data-test-selector*="productListProductCard"] {
                    position: relative;

                    [data-test-selector="textBadges"] {
                        position: absolute;
                        left: 4px;
                        top: calc(0% + 24px);
                    }

                    .product-right-column-container {
                        > [class*="GridOffset"] {
                            width: 100%;
                        }
                    }
                }

                [data-test-selector="productListProductImage"] {
                    padding-top: 30px;
                }

                .listing-add-to-cart {
                    & + div {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                display none;
                            `,
                                    null,
                                ],
                                "max",
                            )}
                    }
                }

                .card_container__wrapper {
                    margin: 0;

                    &:last-child {
                        > [class*="GridItemStyle"] {
                            border-bottom: 0;
                        }
                    }
                }
            }

            .category-top-sellers-carousel {
                background: ${colorPallete.grey100};
                padding-top: 40px;
                padding-bottom: 80px;
                margin-top: 80px;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-left: -16px;
                                margin-right: -16px;
                                width: calc(100% + 32px);
                                margin-top: 32px;
                            `,
                            css`
                                [data-test-selector="productCarousel_topSellers"] {
                                    padding-left: 24px;
                                }
                            `,
                            null,
                        ],
                        "max",
                    )}
            }

            .category-name-wrapper {
                display: flex;
                align-items: center;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                > div {
                                    margin-top: 0;
                                }
                            `,
                        ],
                        "min",
                    )}
                h2 {
                    font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline1SemiBoldLg.lineHeight};
                    font-weight: ${headlineFonts.headline1SemiBoldLg.fontWeight};

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                                    line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                                `,
                                null,
                            ],
                            "max",
                        )}
                }

                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    display: none;
                                `,
                                null,
                            ],
                            "max",
                        )}
                    > div {
                        margin-top: 0;
                        line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                        margin-bottom: 8px;
                    }
                    margin-left: 16px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    width: auto;
                                    white-space: nowrap;
                                `,
                            ],
                            "min",
                        )}
                }
            }

            [data-test-selector="productListCountText"] {
                font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                font-weight: ${headlineFonts.headline3SemiBoldLg.fontWeight};

                & + span {
                    font-size: ${bodyFonts.body2RegularLg.fontSize};
                    line-height: ${bodyFonts.body2RegularLg.lineHeight};
                    font-weight: ${bodyFonts.body2RegularLg.fontWeight};
                }
            }

            [data-test-selector="brand_htmlContent"],
            .category-additional-content-section {
                body {
                    p[class*="TypographyStyle-"],
                    ul[class*="UnorderedListStyle-"] {
                        font-size: ${bodyFonts.body2RegularLg.fontSize};
                        line-height: ${bodyFonts.body2RegularLg.lineHeight};
                        font-weight: ${bodyFonts.body2RegularLg.fontWeight};
                        @media only screen and (max-width: 768px) {
                            font-size: ${bodyFonts.body2RegularSm.fontSize};
                            line-height: ${bodyFonts.body2RegularSm.lineHeight};
                            padding: 0 16px;

                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        null,
                                        css`
                                            padding: 0;
                                        `,
                                        null,
                                    ],
                                    "max",
                                )}
                        }
                    }
                }
            }

            .product-list-controls-container {
                margin-top: 24px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-top: 24px;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }

            .listing-column-container {
                > [class*="GridOffset"] {
                    gap: 40px;
                    width: 100%;
                    flex-wrap: nowrap;

                    @media only screen and (max-width: 1000px) {
                        flex-wrap: wrap;
                    }
                }
            }

            .listing-column-left {
                max-width: 292px;
            }

            .listing-column-right {
                max-width: 938px;
                @media only screen and (max-width: 1000px) {
                    flex-basis: 100%;
                    max-width: 100%;
                    .product-list-controls-container {
                        display: none;
                    }
                }
            }

            .listing-column-left,
            .listing-column-right {
                padding: 0;
            }
            @media screen and (min-width: 768px) and (max-width: 1366px) {
                [data-test-selector="productListCards_Grid"] {
                    > [class*="GridOffset"] {
                        gap: 0;
                        .inventoryWrapper {
                            padding-right: 0;
                        }
                        > div[class*="GridItem"] {
                            max-width: calc(33.33% - 30px);
                            margin-right: 40px !important;
                            flex: 1 1 calc(33.33% - 30px);;
                            &:nth-child(3n){
                                margin-right: 0 !important;
                            }
                        }
                    }
                }
            }
           
        `,
    },
};

const mapStateToProps = (state: CoveoApplicationState) => {
    const location = getLocation(state);
    const { pathname } = getLocation(state);
    const brandPath = getSelectedBrandPath(state) || pathname;
    const selectedCategoryPath = getSelectedCategoryPath(state);
    const pathnameLowerCase = location.pathname.toLowerCase();
    const brandState = getBrandStateByPath(state, brandPath);
    const path =
        selectedCategoryPath ||
        (pathnameLowerCase.startsWith("/content/") || pathnameLowerCase.startsWith("/.spire/")
            ? ""
            : location.pathname);
    const {
        pages: {
            productList: { isLoading, productFilters, parameter, isSearchPage, filterQuery, productInfosByProductId },
        },
    } = state;
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    const productsDataView = getProductsDataView(state, parameter);
    trackGlobalVariableDetails(state);
    return {
        isLoading,
        stockedItemsOnly: productFilters.stockedItemsOnly,
        previouslyPurchasedProducts: productFilters.previouslyPurchasedProducts,
        query: productFilters.query,
        productsDataView,
        firstProductDetailPath: productsDataView.value
            ? productInfosByProductId[productsDataView.value[0]?.id]?.productDetailPath
            : undefined,
        filterQuery,
        isSearchPage,
        search: location.search,
        path,
        breadcrumbLinks: state.components.breadcrumbs.links,
        productListCatalogPage: getCatalogPageStateByPath(state, path).value,
        websiteName: state.context.website.name,
        pages: state.pages,
        location: getLocation(state),
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        websiteSettings: getSettingsCollection(state).websiteSettings,
        searchDataModeActive: getSearchDataModeActive(state),
        searchPath: getSettingsCollection(state).searchSettings.searchPath,
        alternateLanguageUrls: getAlternateLanguageUrls(state, getCurrentPage(state).id),
        brandState,
        brandPath,
        shouldLoadBrand: !brandState.isLoading && !brandState.value && !state.data.brands.pathNotFound[brandPath],
        state,
        page: getCurrentPage(state),
        coveoCommerce: state.DSGGlobalData, // .coveoCommerce
        customSettings: getSettingsCollection(state).customSettings,
    };
};

const mapDispatchToProps = {
    clearAllProductFilters,
    displayProducts,
    setBreadcrumbs,
    clearProducts,
    addProductFilters,
    loadBrandByPath,
    CoveoUIConfigHandler,
    DisplayCatalogData
};

export const ProductListPageDataContext = React.createContext<{ ref?: React.RefObject<HTMLSpanElement> }>({
    ref: undefined,
});

type Props = HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext &
    PageProps;

class BrandDetailPage extends React.Component<Props> {
    afterFilters = React.createRef<HTMLSpanElement>();

    settings = this.props.customSettings as any;
    enableCoveoSearch = this.settings.enableCoveoSearch ?? false;

    loadProducts() {
        const { displayProducts, path, search } = this.props;

        displayProducts({
            path,
            queryString: search,
            isSearch: this.isSearchPath(),
        });
    }
    displayCatalogDataForCoveo() {
            const { path, search } = this.props;
            this.props.DisplayCatalogData({
                path,
                queryString: search,
                isSearch: this.isSearchPath(),
            });
    }

    isSearchPath() {
        return !!this.props.path.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`);
    }

    isCoveoSearchEnable() {
        const settings = this.props.customSettings as any;
        return settings.enableCoveoSearch;
    }

    UNSAFE_componentWillMount(): void {
        const {
            productsDataView,
            location: { pathname },
            CoveoUIConfigHandler,
        } = this.props;

        if(this.enableCoveoSearch && !IS_SERVER_SIDE) { 
            this.displayCatalogDataForCoveo()
            this.setMetadata();                

            CoveoUIConfigHandler({
                page: pathname,
                coveoCommerce: this.props.coveoCommerce,
                defaultPageSize:this.props.websiteSettings?.defaultPageSize ?? 16
            })
        }
        
        if (!this.enableCoveoSearch) {
            if (!productsDataView.value && !productsDataView.isLoading) {
                this.loadProducts();
            } else if (!IS_SERVER_SIDE && productsDataView.value) {
                // Check that the request is not a redirection to where we are currently
                const { searchTermRedirectUrl } = productsDataView;
                if (searchTermRedirectUrl) {
                    const startsWithProtocol = searchTermRedirectUrl.lastIndexOf("http", 0) === 0;
                    const locationPath = startsWithProtocol
                        ? window?.location?.toString()
                        : window?.location?.pathname + window?.location?.search;
                    if (
                        locationPath !== searchTermRedirectUrl &&
                        window?.localStorage?.getItem("searchTermRedirectUrl") !== searchTermRedirectUrl
                    ) {
                        if (startsWithProtocol) {
                            window.location.replace(searchTermRedirectUrl);
                        } else {
                            this.props.history.replace(searchTermRedirectUrl);
                        }
                        return;
                    }
                    if (locationPath === searchTermRedirectUrl) {
                        window?.localStorage?.setItem("searchTermRedirectUrl", searchTermRedirectUrl);
                    }
                }
            } else if (this.props.isSearchPage) {
                this.redirectToProductDetailIfExactMatch();
            }
    
            if (this.props.productListCatalogPage) {
                this.setMetadata();
                if (
                    this.props.breadcrumbLinks?.map(o => o.children?.toString()).join(",") !==
                    this.props.productListCatalogPage.breadCrumbs?.map(o => o.text).join(",")
                ) {
                    this.setProductListBreadcrumbs();
                }
            } else if (this.props.isSearchPage) {
                this.setSearchPageMetadata(translate("Search Results"));
                if (!this.props.breadcrumbLinks) {
                    this.setSearchBreadcrumbs();
                }
            }
        }
    }

    componentWillUnmount(): void { 
        if (this.enableCoveoSearch && this.props.coveoCommerce) {
           this.props.coveoCommerce.UnSubCoveoUIConfigs();
        }
        if (!this.enableCoveoSearch) {
            this.props.clearProducts();
        } 
    }

    componentDidUpdate(prevProps: Props): void {
        const {
            isLoading,
            filterQuery,
            location: { pathname, search },
            productListCatalogPage,
            searchDataModeActive,
            loadBrandByPath,
            brandPath,
            shouldLoadBrand,
            CoveoUIConfigHandler,
            brandState,
            displayProducts,
        } = this.props;

        // Handle brand path changes
        // if (brandPath !== prevProps.brandPath) {
            
            if (shouldLoadBrand && brandPath && !brandPath.toLowerCase().startsWith("/content/page/")) {
                loadBrandByPath({ path: brandPath });
            }
        //}

        // Handle brand state changes
        if (brandState.value && 
            (!prevProps.brandState.value || brandState.value.id !== prevProps.brandState.value.id)) {

            // If we have brand data but no catalog page, trigger the catalog page load
            if (!productListCatalogPage) {
                displayProducts({
                    path: brandPath,
                    queryString: search,
                    isSearch: this.isSearchPath(),
                });
                return;
            }
        }

        // Handle product list catalog page changes
        if (productListCatalogPage) {
            this.setMetadata();
            trackGlobalVariableDetails(this.props.state);
            
            const hasBreadcrumbs = productListCatalogPage.breadCrumbs && productListCatalogPage.breadCrumbs.length > 0;
            const needsBreadcrumbs = !this.props.breadcrumbLinks || 
                JSON.stringify(this.props.breadcrumbLinks) !== 
                JSON.stringify(productListCatalogPage.breadCrumbs?.map(o => ({ children: o.text, href: o.url })));

            if (hasBreadcrumbs && needsBreadcrumbs) {
                this.setProductListBreadcrumbs();
            }
        } else if (this.props.isSearchPage) {
            this.setSearchPageMetadata(translate("Search Results"));
            trackGlobalVariableDetails(this.props.state);
            if (this.props.query !== prevProps.query || !this.props.breadcrumbLinks) {
                this.setSearchBreadcrumbs();
            }
        }

        if (this.props.query !== prevProps.query) {
            window?.localStorage?.removeItem("searchTermRedirectUrl");
        }

        if (this.enableCoveoSearch) {
            if(!this.props.coveoCommerce.CoveoIsInitialized){
                CoveoUIConfigHandler({
                    page: pathname,
                    coveoCommerce: this.props.coveoCommerce,
                    defaultPageSize:this.props.websiteSettings?.defaultPageSize ?? 16
                })
            }
            
            if(brandPath !== prevProps.path) {
                CoveoUIConfigHandler({
                    page: pathname,
                    coveoCommerce: this.props.coveoCommerce,
                    defaultPageSize:this.props.websiteSettings?.defaultPageSize ?? 16
                })              
            }
            // Do not run any elastic plp or search page logic if the coveo search is enabled for all the users
            return; 
        }

        // handle the query string change requests initiated by the filtering widget setQueryFilter calls
        // Make sure we are fully loaded, since a loading product list will change the filteQuery to match the current pathname/search
        // This can trigger a loop with the pathname/search updating and the filterQuery not updated till the productList is loaded
        if (!isLoading && filterQuery !== prevProps.filterQuery) {
            const currentUrl = `${pathname}${search}`;
            const newUrl = filterQuery ? `${pathname}?${filterQuery}` : pathname;
            if (newUrl !== currentUrl) {
                this.props.history.push(newUrl);
                return;
            }
        }

        if (!isLoading && this.props.productsDataView.value && pathname === prevProps.location.pathname) {
            // Check that the request is not a redirection to where we are currently
            const { searchTermRedirectUrl } = this.props.productsDataView;
            if (searchTermRedirectUrl) {
                const startsWithProtocol = searchTermRedirectUrl.lastIndexOf("http", 0) === 0;
                const locationPath = startsWithProtocol
                    ? window?.location?.toString()
                    : window?.location?.pathname + window?.location?.search;
                if (
                    locationPath !== searchTermRedirectUrl &&
                    window?.localStorage?.getItem("searchTermRedirectUrl") !== searchTermRedirectUrl
                ) {
                    if (startsWithProtocol) {
                        window.location.replace(searchTermRedirectUrl);
                    } else {
                        this.props.history.replace(searchTermRedirectUrl);
                    }
                    return;
                }
                if (locationPath === searchTermRedirectUrl) {
                    window?.localStorage?.setItem("searchTermRedirectUrl", searchTermRedirectUrl);
                }
            }

            this.redirectToProductDetailIfExactMatch();
        }

        if (
            !isLoading &&
            (search !== prevProps.search || this.props.path !== prevProps.path) &&
            search?.indexOf("criteria=") === -1
        ) {
            if (this.props.path !== prevProps.path) {
                this.props.clearAllProductFilters({
                    removeAll: true,
                });
            }
            this.loadProducts();
        }

        if (searchDataModeActive !== prevProps.searchDataModeActive) {
            // refresh the search results when search data mode has been toggled in the cms shell
            this.loadProducts();
        }

        if (
            !prevProps.productsDataView.value &&
            this.props.productsDataView.value &&
            this.props.productsDataView.pagination &&
            this.props.productsDataView.value.length === 0 &&
            this.props.productsDataView.pagination.totalItemCount > 0
        ) {
            this.props.addProductFilters({ page: 1 });
        }
    }

    redirectToProductDetailIfExactMatch() {
        if (!this.props.productsDataView.value) {
            return;
        }

        const {
            location: { search },
            firstProductDetailPath,
        } = this.props;

        const { exactMatch, value: products } = this.props.productsDataView;
        if (exactMatch && products.length) {
            let productDetailUrl = firstProductDetailPath ?? products[0].canonicalUrl;
            const parsedQuery = parseQueryString<{ criteria: string; query: string }>(search);
            const query = parsedQuery.criteria || parsedQuery.query;
            if (!query) {
                return;
            }
            if (productDetailUrl.indexOf("?") !== -1) {
                productDetailUrl += `&criteria=${encodeURIComponent(query)}`;
            } else {
                productDetailUrl += `?criteria=${encodeURIComponent(query)}`;
            }

            if (IS_SERVER_SIDE) {
                setStatusCode(302);
                redirectTo(productDetailUrl);
            } else {
                this.props.history.replace(productDetailUrl);
            }
        }
    }

    getQueryStrings() {
        if (this.props.productsDataView.value && this.props.productsDataView.pagination) {
            const { prevPageUri, nextPageUri, currentPage } = this.props.productsDataView.pagination;
            const { prevQueryString, currentQueryString, nextQueryString } = getPrevCurrentNextQueryString(
                prevPageUri,
                nextPageUri,
                currentPage,
                this.props.filterQuery ?? "",
            );
            return { prevQueryString, currentQueryString, nextQueryString };
        }

        const { prevQueryString, currentQueryString, nextQueryString } = getPrevCurrentNextQueryString("", "", 1, "");
        return { prevQueryString, currentQueryString, nextQueryString };
    }

    setMetadata() {
        const { productListCatalogPage, websiteName, location, websiteSettings } = this.props;
        if (!productListCatalogPage) {
            return;
        }

        const { 
            metaDescription,
            metaKeywords,
            openGraphImage,
            openGraphTitle,
            openGraphUrl,
            title,
            primaryImagePath,
            canonicalPath,
            alternateLanguageUrls,
        } = productListCatalogPage;

        const { prevQueryString, currentQueryString, nextQueryString } = this.getQueryStrings();

        setPageMetadata(
            {
                metaDescription,
                metaKeywords,
                openGraphImage: openGraphImage || primaryImagePath,
                openGraphTitle,
                openGraphUrl,
                title,
                currentPath: location.pathname,
                canonicalPath,
                alternateLanguageUrls: alternateLanguageUrls ?? undefined,
                websiteName,
                currentQueryString,
                prevQueryString,
                nextQueryString,
                structuredPageData: websiteSettings.enableBreadcrumbStructuredData
                ? prepareBreadcrumbStructuredPageData(this.props.breadcrumbLinks?.filter(x=>x.children != "Shop All Products"))
                : undefined,
            jsonLdScriptId: getJsonLdScriptId(this.props.page.type),
            },
            websiteSettings,
        );
    }

    setSearchPageMetadata(title: string) {
        const { websiteName, location, websiteSettings, fields, productsDataView, alternateLanguageUrls } = this.props;
        const firstProduct = productsDataView.value && productsDataView.value[0];
        const { prevQueryString, currentQueryString, nextQueryString } = this.getQueryStrings();

        setPageMetadata(
            {
                title,
                currentPath: location.pathname,
                websiteName,
                openGraphImage:
                    fields.openGraphImage ||
                    firstProduct?.largeImagePath ||
                    firstProduct?.mediumImagePath ||
                    firstProduct?.smallImagePath,
                openGraphTitle: fields.openGraphTitle,
                alternateLanguageUrls,
                currentQueryString,
                prevQueryString,
                nextQueryString,
            },
            websiteSettings,
        );
    }

    setProductListBreadcrumbs() {
        if (!this.props.productListCatalogPage?.breadCrumbs) {
            return;
        }

        const breadcrumbLinks = this.props.productListCatalogPage.breadCrumbs.map(o => ({ 
            children: o.text, 
            href: o.url 
        }));

        if (breadcrumbLinks.length > 0) {
            this.props.setBreadcrumbs({
                links: breadcrumbLinks,
            });
        }
    }

    setSearchBreadcrumbs() {
        this.props.setBreadcrumbs({
            links: [
                { children: translate("Home_Breadcrumb"), href: "/" },
                { children: `${translate("Search Results")}: ${this.props.query}` },
            ],
        });
    }

    styles = productListingPageStyles;

    render() {
        if (this.props.productsDataView.value?.length && this.props.productsDataView.exactMatch) {
            // prevent a flash of data when PLP immediately redirects to PDP
            return null;
        }

        return (
           
            <Page className={`${this.isCoveoSearchEnable() 
                ? 'coveoProductListingPage' 
                : `product-listing-page ${this.props.isSearchPage ? 'search-listing-page' : ''} 
                    ${this.props.isSearchPage && this.props.productsDataView.value?.length === 0 ? 'search-listing-not-found' : ''}`
                }`}
            
            {...this.styles.page}>
                <BrandStateContext.Provider value={this.props.brandState}>
                    <CategoryContext.Provider value={this.props.category}>
                        <ProductListPageDataContext.Provider value={{ ref: this.afterFilters }}>
                            <Zone contentId={this.props.id} zoneName="Content" />
                            <Modals />
                            <ProductCompareFlyOut />
                        </ProductListPageDataContext.Provider>
                    </CategoryContext.Provider>
                </BrandStateContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(BrandDetailPage)),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsCategorySelection: true,
        pageType: "System",
        fieldDefinitions: [HideHeader, HideFooter, OpenGraphTitle, OpenGraphImage],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "ProductListPage" instead of this constant.
 */
export const ProductListPageContext = "BrandDetailsPage";

// const pageModule: PageModule = {
//     component: connect(mapStateToProps, mapDispatchToProps)(BrandDetailsPage),
//     definition: {
//         hasEditableUrlSegment: false,
//         hasEditableTitle: true,
//         supportsBrandSelection: true,
//         pageType: "System",
//     },
// };

// export default pageModule;

// export const BrandDetailsPageContext = "BrandDetailsPage";
